import { app, auth, db } from '@src/firebase'
import { userAuthLogoutAction } from '@actions'
import addToaster from '@shared/Notification'
import { setLodingStatusAction } from '@actions'
import store from '@store'
import { getAppURL } from '@utils/'
import { sendEmailServerApi } from './notification'
import { EMAIL_TEMPLATE_ID } from '@constants/index'


/** Signup user using email, password
 * @param {Object} payload
 * @param {string} payload.email
 * @param {string} payload.password
 */
export const callUserSignupApi = async payload => {
  const { email, password } = payload
  store.dispatch(setLodingStatusAction(true))
  try {
    const data = await auth.createUserWithEmailAndPassword(email, password)

    store.dispatch(setLodingStatusAction(false))
    return { data, status: 200 }
  } catch (error) {
    store.dispatch(setLodingStatusAction(false))
    console.log(error)
    addToaster('error', error.message)
  }
}

/** Signin user using email, password
 * @param {Object} payload
 * @param {string} payload.email
 * @param {string} payload.password
 */
export const callUserSigninWithEmailPasswordApi = async payload => {
  //console.log(payload)
  const { email, password } = payload
  store.dispatch(setLodingStatusAction(true))
  try {
    const data = await auth.signInWithEmailAndPassword(email, password)
    store.dispatch(setLodingStatusAction(false))
    //console.log(payload)

    return { data, status: 200 }
  } catch (error) {
    store.dispatch(setLodingStatusAction(false))
    // addToaster('error', error.message)
    //console.log(error)
    return { data: error, status: 500 }
  }
}

export const onAuthStateChanged = async () => {
  auth.onAuthStateChanged(async (user) => {
    if (user !== null) {
      const { emailVerified, uid } = user;
      const dbUser = db.collection('users').doc(uid);
      const userinfo = (await dbUser.get()).data()
      if (userinfo && !userinfo.emailVerified) {
        await dbUser.update({ emailVerified });
      }
    } else {
      store.dispatch(userAuthLogoutAction())
    }
  })
}

/** Get current login user token
 */
export const callCurrentUserTokenIdApi = () => {
  return auth.currentUser.getIdToken(/* forceRefresh */ true)
}

// Sign in with Google.
export const signInWithGoogle = async () => {
  return new Promise(async (resolve, reject) => {
    store.dispatch(setLodingStatusAction(true))
    try {
      const provider = new app.auth.GoogleAuthProvider()
      const data = await auth.signInWithPopup(provider);
      const { user, additionalUserInfo: { isNewUser } = {}, credential: { accessToken } = {} } = data;
      store.dispatch(setLodingStatusAction(false))
      resolve({ status: 200, data: { user, additionalUserInfo: { isNewUser }, credential: { accessToken } } })
    } catch (error) {
      store.dispatch(setLodingStatusAction(false))
      addToaster('error', error.message)
      reject({ status: 400 })
    }
  });
}

/** Sign out user using email, password
 */
export const callUserSignOutApi = async () => {
  store.dispatch(setLodingStatusAction(true))
  try {
    await auth.signOut()
    store.dispatch(setLodingStatusAction(false))
    return { status: 200 }
  } catch (error) {
    store.dispatch(setLodingStatusAction(false))
    addToaster('error', error.message)
    return { status: 400 }
  }
}

/** Reset user password, using user email
 */
export const callUserPasswordResetApi = async email => {
  store.dispatch(setLodingStatusAction(true))
  try {
    const data = await auth.sendPasswordResetEmail(email)
    addToaster('success', 'Please check inbox')
    store.dispatch(setLodingStatusAction(false))
    return { status: 200, data }
  } catch (error) {
    store.dispatch(setLodingStatusAction(false))
    addToaster('error', error.message)
  }
}

/** Send email verification */
export const callUserSendEmailVerification = async () => {
  store.dispatch(setLodingStatusAction(true))
  try {
    const data = await auth.currentUser.sendEmailVerification()
    store.dispatch(setLodingStatusAction(false))
    return data
  } catch (error) {
    store.dispatch(setLodingStatusAction(false))
    addToaster('error', error.message)
  }
}

export const ensureLoggedIn = (userId, addToaster) => {
  if (!userId) {
    if (addToaster) {
      addToaster('error', 'Please log in to generate your referral link.')
    }
    return false
  }
  return true
}
